import { useDrawerStore } from '../../../store';
import {
  useCreateData,
  useFetchData,
  useLineStore,
  useUpdateData,
} from '../../../hooks';
import React, { useEffect, useState } from 'react';
import { BaseModel, FormField, PageableResponse } from '../../../types';
import { Resource } from '../../../lib/enums';
import { Spin } from 'antd';
import FormDrawer from '../../../components/ui/FormDrawer';
import ErrorModal from '../../../components/ui/modal/ErrorModal';

const LineForm = ({ api, moduleName }: { api: string; moduleName: string }) => {
  const drawerStore = useDrawerStore();
  const lineStore = useLineStore();
  const [spinning, setSpinning] = useState<boolean>(false);
  const [isInfoModalOpen, setInfoModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>('');

  const { data: sectionData, isLoading: isSectionLoading } = useFetchData<
    PageableResponse<BaseModel>
  >('/sections', {
    resource: Resource.MIN,
    search: '',
    length: '999999',
  });

  const {
    mutate,
    isSuccess: isSuccessCreate,
    isError: isErrorCreate,
    error: errorCreate,
  } = useCreateData(api);
  const {
    mutate: mutateUpdate,
    isSuccess: isSuccessUpdate,
    isError: isErrorUpdate,
    error: errorUpdate,
  } = useUpdateData(api);

  const onFinish = (values: { section: string }) => {
    setSpinning(true);
    const section: BaseModel | undefined = sectionData?.data?.find((obj) => {
      return obj.id == values.section;
    });
    const jsonData = {
      ...values,
      section: section,
    };

    if (lineStore.data !== null) {
      const updatedData = {
        ...lineStore.data,
        ...jsonData,
      };
      mutateUpdate({ id: lineStore.data.id, form: updatedData });
    } else {
      mutate(jsonData);
    }
  };

  const formFields: FormField[] = [
    {
      name: 'code',
      label: 'Code',
      rules: [{ required: true, message: 'Please enter Code' }],
      disabled: lineStore.data != null,
      defaultValue: lineStore.data?.code,
    },
    {
      name: 'description',
      label: 'Description',
      rules: [{ required: true, message: 'Please enter description' }],
      defaultValue: lineStore.data?.description,
    },
    {
      name: 'section',
      label: 'Section',
      rules: [{ required: true, message: 'Please select section' }],
      values: sectionData?.data,
      isMultiple: false,
      isLoading: isSectionLoading,
      type: 'select',
      allowClear: true,
      defaultValue: lineStore.data?.section?.id,
    },
  ];

  useEffect(() => {
    if (isSuccessCreate || isSuccessUpdate || isErrorUpdate || isErrorCreate)
      setSpinning(false);

    if (isErrorUpdate) {
      setInfoModalOpen(true);
      setErrorMessage(errorUpdate?.response?.data.message);
    }
    if (isErrorCreate) {
      setInfoModalOpen(true);
      setErrorMessage(errorCreate?.response?.data.message);
    }
  }, [
    isSuccessCreate,
    isSuccessUpdate,
    isErrorUpdate,
    isErrorCreate,
    errorCreate,
  ]);

  return (
    <>
      <Spin spinning={spinning} fullscreen />
      <FormDrawer
        isOpen={drawerStore.isOpen}
        onClose={drawerStore.onClose}
        data={lineStore.data}
        moduleName={moduleName}
        setData={lineStore.setData}
        onFinish={onFinish}
        formFields={formFields}
      />
      <ErrorModal
        visible={isInfoModalOpen}
        message={errorMessage}
        onClose={() => setInfoModalOpen(false)}
      />
    </>
  );
};
export default LineForm;
